import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import * as React from "react";

import SideNavigation from "../SideNavigation";
import { DesktopDrawer } from "./DesktopDrawer";
import MobileDrawer from "./MobileDrawer";

/** App shell row: mobile + desktop sidebars and the main content area. */
export default function AppDrawer({ children }: React.PropsWithChildren) {
    return (
        <Stack direction="row" sx={{ flex: 1, minHeight: 0 }}>
            <MobileDrawer sx={{ display: { xs: "block", sm: "none" } }}>
                <SideNavigation />
            </MobileDrawer>

            <DesktopDrawer sx={{ display: { xs: "none", sm: "block" } }}>
                <SideNavigation />
            </DesktopDrawer>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    // we need minWidth for the MUI datagrids to resize properly
                    minWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 0,
                }}
            >
                {children}
            </Box>
        </Stack>
    );
}
